import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

import { Typography as TypographyCr } from '@creditas/typography'
import { Button } from '@creditas/button'
import { styled } from '@creditas/stylitas'

import { MainWrapper } from 'components/MainWrapper'
import { FlexContainer } from 'components/Flex'
import { GridItem, GridContainer as GridContainerCr } from 'components/Grid'

import { Illustration } from './Illustration'

const GridContainer = styled(GridContainerCr)`
  padding-bottom: 50px;
  padding-top: 146px;
`

const Typography = styled(TypographyCr)`
  margin-bottom: 8px;
`

function goBack() {
  window.history.back()
}

const GenericError = () => {
  const { t } = useTranslation(['genericError'])

  return (
    <MainWrapper style={{ backgroundColor: '#f8f8f8' }}>
      <FlexContainer column maxWidth="1170px">
        <GridContainer verticalGap="0px">
          <GridItem startCol={1} endCol={13}>
            <Typography variant="h2">{t('title')}</Typography>
          </GridItem>
          <GridItem startCol={1} endCol={6}>
            <Typography variant="h4">{t('subtitle')}</Typography>
            <Typography variant="button" color="#556666">
              {t('important')}
            </Typography>
            <div style={{ marginTop: 32, width: 370 }}>
              <Typography variant="paragraph">
                <Trans
                  i18nKey="genericError:message"
                  // eslint-disable-next-line react/jsx-key
                  components={[<br />]}
                />
              </Typography>
            </div>
            <Button style={{ marginTop: 28 }} onClick={goBack}>
              {t('backAction')}
            </Button>
          </GridItem>

          <GridItem startCol={7} endCol={13}>
            <Illustration />
          </GridItem>
        </GridContainer>
      </FlexContainer>
    </MainWrapper>
  )
}

export { GenericError }
